import DealRoomFieldsRequiredVisibleInfoProvider from './DealRoomFieldsRequiredVisibleInfo.provider';

export default DealRoomFieldsRequiredVisibleInfoProvider;
